<template>
  <el-dialog
    title="指标应用配置"
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog"
    :close-on-click-modal="false"
    @open="handleOpen"
  >
    <div class="plan-container" v-for="(plan, index) in plans" :key="plan.value">
      <span style="color: var(--theme-color);">{{plan.name}}</span>
      <span style="display: inline-block; margin-right: 15px;">应用到年级</span>
      <div style="display: inline-block;">
        <el-checkbox-group
          v-model="planActiveGrade[index]"
          size="medium"
          @change="(val) => changeActiveGrade(val, index, plan)"
        >
          <el-checkbox
            v-for="item in plan.grades"
            :key="item.value"
            :label="item.value"
            :disabled="item.disabled"
            border
          >{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button size="small" type="primary" :disabled="submitting" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
// import __ from '@/util/common-utils'
export default {
  props: ['identify', 'visible'],
  data () {
    return {
      plans: [
        {
          name: '指标方案一',
          value: 1,
          grades: [
            {
              name: '一年级',
              value: 1,
              disabled: false
            },
            {
              name: '二年级',
              value: 2,
              disabled: false
            },
            {
              name: '三年级',
              value: 3,
              disabled: false
            },
            {
              name: '四年级',
              value: 4,
              disabled: false
            },
            {
              name: '五年级',
              value: 5,
              disabled: false
            },
            {
              name: '六年级',
              value: 6,
              disabled: false
            }
          ]
        },
        {
          name: '指标方案二',
          value: 2,
          grades: [
            {
              name: '一年级',
              value: 1,
              disabled: false
            },
            {
              name: '二年级',
              value: 2,
              disabled: false
            },
            {
              name: '三年级',
              value: 3,
              disabled: false
            },
            {
              name: '四年级',
              value: 4,
              disabled: false
            },
            {
              name: '五年级',
              value: 5,
              disabled: false
            },
            {
              name: '六年级',
              value: 6,
              disabled: false
            }
          ]
        },
        {
          name: '指标方案三',
          value: 3,
          grades: [
            {
              name: '一年级',
              value: 1,
              disabled: false
            },
            {
              name: '二年级',
              value: 2,
              disabled: false
            },
            {
              name: '三年级',
              value: 3,
              disabled: false
            },
            {
              name: '四年级',
              value: 4,
              disabled: false
            },
            {
              name: '五年级',
              value: 5,
              disabled: false
            },
            {
              name: '六年级',
              value: 6,
              disabled: false
            }
          ]
        }
      ],
      planActiveGrade: [[], [], []],
      resData: [],
      submitting: false,
      isLastSuccessful: false
    }
  },
  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    }
  },
  mounted () {

  },
  methods: {
    handleOpen () {
      this.submitting = false
      this.planActiveGrade = [[], [], []]
      this.$xhrGet(`/eval/indicators/grade-setting`).then(rs => {
        this.resData = _.cloneDeep(rs.data)
        for (let index = 0; index < rs.data.length; index++) {
          let element = rs.data[index]
          this.planActiveGrade[index] = element.gradeIdList
          this.changeActiveGrade(element.gradeIdList, index)
        }
      })
      for (let index = 0; index < this.plans.length; index++) {
        let element = this.plans[index].grades
        for (let innerIndex = 0; innerIndex < element.length; innerIndex++) {
          let innerEle = element[innerIndex]
          innerEle.disabled = false
        }
      }
    },

    closeDialog () {
      if (this.isLastSuccessful) {
        this.$emit('edit-result', true)
      }
      this.$emit('update:visible', false)
    },

    changeActiveGrade (val, index) {
      let activeGradeArr = [...new Set([].concat(...this.planActiveGrade))]
      // 将其余方案内的相同年级禁用或解禁
      for (let planIndex = 0; planIndex < this.plans.length; planIndex++) {
        let element = this.plans[planIndex]
        if (planIndex !== index) {
          for (let gradeIndex = 0; gradeIndex < element.grades.length; gradeIndex++) {
            let gradeEle = element.grades[gradeIndex]
            if (activeGradeArr.includes(gradeEle.value)) {
              if (!this.planActiveGrade[planIndex].includes(gradeEle.value)) {
                gradeEle.disabled = true
              }
            } else {
              gradeEle.disabled = false
            }
          }
        }
      }
    },

    submit () {
      this.submitting = true
      let resData = _.cloneDeep(this.resData)
      for (let index = 0; index < resData.length; index++) {
        let element = resData[index]
        element.gradeIdList = this.planActiveGrade[index]
      }
      this.$xhrPut(`/eval/indicators/grade-setting`, resData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.isLastSuccessful = true
          this.$message.success('操作成功')
          this.closeDialog()
        } else {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  border: none;
}
.plan-container {
  min-height: 40px;
  line-height: 20px;
  margin-bottom: 20px;
}
/deep/ .el-checkbox__input {
  display: none;
}
/deep/ .el-checkbox.is-checked {
  background: #eeeefd;
  color: var(--theme-color);
}
/deep/ .el-checkbox-group {
  display: inline-block;
}
/deep/ .el-checkbox--medium {
  margin: 0 15px 0 0;
}
/deep/ .el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}
/deep/ .el-dialog__footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/apply/PlanApplyEditor.vue